import { render } from "./YearChose.vue?vue&type=template&id=2b049496"
import script from "./YearChose.vue?vue&type=script&lang=js"
export * from "./YearChose.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__